import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function BarChart({ categories }) {
  
  const data = {
    labels: categories.map(c => c.category?.name || c.name || 'N/A'),
    datasets: [
      {
        label: 'Puntaje',
        data: categories.map(c => c.average || c.score || 0),
        backgroundColor: 'rgba(54, 162, 235, 0.7)', 
        borderColor: 'rgba(54, 162, 235, 1)',      
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, 
    scales: {
      y: {
        beginAtZero: true,
        max: 5,
        ticks: { color: '#333', font: { weight: 'bold' }, stepSize: 1 },
        grid: { color: '#e5e5e5' }
      },
      x: {
        ticks: { color: '#333', font: { size: 10 }, autoSkip: false, maxRotation: 45, minRotation: 0 },
        grid: { display: false }
      }
    },
    plugins: {
      legend: { display: false }, 
      tooltip: { enabled: true }
    }
  };

  return <Bar data={data} options={options} />;
}

export default BarChart;